"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRndApi = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var withHttpClient_1 = require("../hocs/withHttpClient");
var rndApi = function (_a) {
    var httpClient = _a.httpClient;
    var createLead = function (data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: "leads",
                        data: data,
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var updateLead = function (code, data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.patch({
                        endpoint: "leads/".concat(code),
                        data: data,
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var fetchLead = function (clientId) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: "leads/".concat(clientId),
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var fetchQuiz = function (variant) {
        if (variant === void 0) { variant = 'main'; }
        return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, httpClient.get({
                            endpoint: "quizzes/".concat(variant),
                        })];
                    case 1:
                        res = _a.sent();
                        return [2, res.data.data];
                }
            });
        });
    };
    var fetchProducts = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: 'products',
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var fetchUpsells = function (code) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: "upsells/".concat(code),
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data];
            }
        });
    }); };
    var fetchProjectConfig = function (provider) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var queryParams, res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryParams = provider ? { gateway: provider } : undefined;
                    return [4, httpClient.get({
                            endpoint: "project",
                            queryParams: queryParams,
                        })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var createShippingInfo = function (clientId, orderId, data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: "clients/".concat(clientId, "/orders/").concat(orderId, "/addresses"),
                        data: data,
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var createUpsellsCart = function (clientId, data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: "clients/".concat(clientId, "/orders/prepare"),
                        data: data,
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var createSubscriber = function (clientId, data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: "leads/".concat(clientId, "/subscriber"),
                        data: data,
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var setMailerLiteData = function (clientId, data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: "leads/".concat(clientId, "/subscriber"),
                        data: data,
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.status];
            }
        });
    }); };
    var buyOneClick = function (upsellUrl) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.post(upsellUrl)];
                case 1:
                    res = _a.sent();
                    return [2, res.data];
            }
        });
    }); };
    var createExternalId = function (clientId, key, value) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var data, res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        key: key,
                        value: value,
                    };
                    return [4, httpClient.post({
                            endpoint: "leads/".concat(clientId, "/external_data"),
                            data: data,
                        })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var fetchExternalData = function (clientCode) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: "external_data/uid:".concat(clientCode),
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var fetchCoupon = function (coupon) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: "coupons/".concat(coupon),
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var fetchCouponByProductsId = function (coupon, productsId) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: "coupons/".concat(coupon),
                        data: { products: productsId },
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var getUserGeolaction = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: 'geolocation',
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var attachAffiliateToOrder = function (orderId, affiliateCode) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: "orders/".concat(orderId, "/attach/affiliate"),
                        data: {
                            affiliate_code: affiliateCode,
                        },
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data];
            }
        });
    }); };
    var fetchShippingCosts = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: 'shipping_costs',
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data || []];
            }
        });
    }); };
    var fetchOrderSummary = function (data, queryParams) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: 'orders/amount',
                        data: data,
                        queryParams: queryParams,
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var trackDataForKiloAnalyticsApi = function (trigger, data) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            httpClient.post({
                endpoint: "analytics/".concat(trigger),
                data: data,
            });
            return [2];
        });
    }); };
    var fetchClientSubscriptions = function (clientCode) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.get({
                        endpoint: "clients/".concat(clientCode, "/subscriptions"),
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data.data];
            }
        });
    }); };
    var sendManageSubscriptionEmail = function (email) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var res;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, httpClient.post({
                        endpoint: 'subscriptions/email/send',
                        data: {
                            email: email,
                        },
                    })];
                case 1:
                    res = _a.sent();
                    return [2, res.data];
            }
        });
    }); };
    var cancelUserSubscription = function (subscriptionId, clientID, data) {
        if (data === void 0) { data = []; }
        return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, httpClient.post({
                            endpoint: "payments/subscriptions/cancel",
                            data: {
                                subscription_id: subscriptionId,
                                client_code: clientID,
                                data: data,
                            },
                        })];
                    case 1:
                        res = _a.sent();
                        return [2, res.data.data];
                }
            });
        });
    };
    return {
        fetchExternalData: fetchExternalData,
        fetchLead: fetchLead,
        fetchQuiz: fetchQuiz,
        fetchProducts: fetchProducts,
        fetchUpsells: fetchUpsells,
        createUpsellsCart: createUpsellsCart,
        fetchProjectConfig: fetchProjectConfig,
        createLead: createLead,
        updateLead: updateLead,
        createShippingInfo: createShippingInfo,
        createSubscriber: createSubscriber,
        setMailerLiteData: setMailerLiteData,
        buyOneClick: buyOneClick,
        createExternalId: createExternalId,
        fetchCoupon: fetchCoupon,
        fetchCouponByProductsId: fetchCouponByProductsId,
        getUserGeolaction: getUserGeolaction,
        sendManageSubscriptionEmail: sendManageSubscriptionEmail,
        attachAffiliateToOrder: attachAffiliateToOrder,
        fetchShippingCosts: fetchShippingCosts,
        fetchOrderSummary: fetchOrderSummary,
        trackDataForKiloAnalyticsApi: trackDataForKiloAnalyticsApi,
        fetchClientSubscriptions: fetchClientSubscriptions,
        cancelUserSubscription: cancelUserSubscription,
    };
};
exports.createRndApi = (0, withHttpClient_1.withHttpClient)(rndApi);
